import React from 'react'
import { Link } from '@ta-interaktiv/contentbricks'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
const isMobile = browserCheck.isMobile

export const qanda = [
  {
    id: 'luxusuhr-1',
    type: 'slider',
    unit: 'CHF',
    question: 'Wie hoch schätzen Sie den Wert dieser Uhr?',
    correctAnswer: 120000,
    clockType: 'Jaeger Le Coultre Master Grande Tradition Minute Repeater',
    erklaerung: (
      <>
        <h5>Zum Vergleich:</h5>
        <p>
          120’000 Franken. Das entspricht etwa 40’000-mal dem monatlichen
          Mindestlohn in Venezuela.
        </p>
      </>
    )
  },
  {
    id: 'luxusuhr-2',
    type: 'slider',
    unit: 'CHF',
    question: 'Wie hoch schätzen Sie den Wert dieser Uhr?',
    correctAnswer: 70000,
    clockType: 'Rolex Daytona Cosmograph (Platinum)',
    erklaerung: (
      <>
        <h5>Zum Vergleich:</h5>
        <p>
          70’000 Franken. Der 70-jährige Venezolaner Sergio Hernández, über den
          SRF im Dezember{' '}
          <Link
            allowWordWrap
            href='https://www.srf.ch/news/international/armut-in-venezuela-die-verlassenen-alten'
          >
            berichtete
          </Link>
          , erhält eine monatliche Altersrente von umgerechnet 1 Dollar. Sein
          bescheidenes Zimmer kostet 15 Dollar im Monat.
        </p>
      </>
    )
  },
  {
    id: 'luxusuhr-3',
    type: 'slider',
    unit: 'CHF',
    question: 'Wie hoch schätzen Sie den Wert dieser Uhr?',
    correctAnswer: 300000,
    clockType: 'Greubel Forsey GMT Global Double Tourbillon (Weissgold)',
    erklaerung: (
      <>
        <h5>Zum Vergleich:</h5>
        <p>
          300’000 Franken. Das entspricht etwa 170-mal dem Bruttoinlandprodukt
          Venezuelas pro Kopf.
        </p>
      </>
    )
  },
  {
    id: 'luxusuhr-4',
    type: 'slider',
    unit: 'CHF',
    question: 'Wie hoch schätzen Sie den Wert dieser Uhr?',
    correctAnswer: 100000,
    clockType:
      'Hublot Big Bang Chronography Tourbillon, Spezialmodell zu 20 Jahren Ferrari in China',
    erklaerung: (
      <>
        <h5>Zum Vergleich:</h5>
        <p>
          100’000 Franken. Gemäss einer{' '}
          <Link
            allowWordWrap
            href='https://usunrome.usmission.gov/under-maduro-nearly-all-venezuelans-live-in-poverty/'
          >
            Studie
          </Link>{' '}
          der Andrés Bello Catholic University in Caracas lebten 2019 zwei von
          drei Haushalten in Venezuela in Armut. Die Versorgung mit Nahrung wird
          in der Studie nur für jeden 33. Haushalt als sicher eingestuft.
        </p>
      </>
    )
  },
  {
    id: 'luxusuhr-5',
    type: 'slider',
    unit: 'CHF',
    question: 'Wie hoch schätzen Sie den Wert dieser Uhr?',
    correctAnswer: 90000,
    clockType: 'Patek Philippe Nautilus',
    erklaerung: (
      <>
        <h5>Zum Vergleich:</h5>
        <p>
          90’000 Franken. Mit dieser einen Uhr könnten sich zahlreiche
          Venezolaner aus der Armut befreien. «Ich sehe Menschen aus
          Abfallkübeln essen. So was gab es früher nie. Zahnpasta, Seife oder
          Waschpulver sind zu Luxusgütern geworden.» Das sagte der nach
          Venezuela ausgewanderte Schweizer Hanspeter Rieder 2019 der «Schweizer
          Illustrierten».
        </p>
      </>
    )
  }
]
